module.exports = __webpack_public_path__ + "assets/img/正骨4.e3e94db9.jpg";